import React, { Component } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import { withRouter }  from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import { KeepAlive } from '../../utils/ApplicationApi';

import './TimeOut.scss';

class TimeOut extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
    this.idleTimer = null;
    this.onActive = this.onActive.bind(this);
    this.onIdle = this.onIdle.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.keepSessionAlive = this.keepSessionAlive.bind(this);
  }
  componentDidMount() {
    this.keepSessionAlive();

    let intervalId = setInterval(() => {
      let path = this.props.location.pathname;    
      let route = `/${path.split("/")[1]}`;

      if(route === "/WhatsNext" || route === "/TimeOut" || route === "/Error") {
        this.idleTimer.pause();
        clearInterval(this.state.intervalId);
      }
      if(route !== "/TimeOut" && route !== "/WhatsNext" && route !== "/Error" && this.idleTimer.getRemainingTime() <= 120000) {
        this.setState({modalOpen: true});
      }
    }, 1000);
    this.setState({
      intervalId: intervalId
    });
  }
  componentDidUpdate(prevProps) {
    if(prevProps.location.pathname !== this.props.location.pathname) {
      // Call keep session alive whenever path changes
      this.keepSessionAlive();
    }
  }
  keepSessionAlive() {
    const path = this.props.location.pathname;    
    const route = `/${path.split("/")[1]}`;

    if(this.keepAliveInterval !== undefined) {
      clearInterval(this.keepAliveInterval);
    }
    if(route !== "/TimeOut" && route !== "/WhatsNext" && route !== "/Error") {
      this.keepAliveInterval = setInterval(() => {
        // Only keep alive if the app isn't about to timeout on it's own.
        if(this.idleTimer.getRemainingTime() > 120000) {
          KeepAlive();
        }
      }, 300000);
    }
  }
  componentWillUnmount() 
  {
    clearInterval(this.state.intervalId);
  }
  onActive(e) {
  }
  onIdle(e) {        
    this.closeModal();
    this.idleTimer.pause();
    this.props.history.replace('/TimeOut');
    clearInterval(this.state.intervalId);
  }
  closeModal() {
    KeepAlive();
    this.setState({modalOpen: false});
  }
  exitApp() {
    //rediret to Vancity.com
    window.location.replace("https://www.vancity.com")
  }
  render() {
    const modalCloseButton = <div className="close-modal" onClick={this.closeModal}></div>    
    return (
      <div>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          timeout={600000} />     
        <Modal isOpen={this.state.modalOpen} centered={true} className="app-timeout-modal"  modalClassName="app-timeout">
          {modalCloseButton}
          <ModalBody>
            <h2>Your application is about to timeout!</h2>  
            <p>What would you like to do?</p>          
            <div className="button-container">
              <Button onClick={this.closeModal} color="primary">Keep going</Button><Button onClick={this.exitApp}>Exit</Button>
            </div>
          </ModalBody>
        </Modal>   
      </div>
    );
  }
}

export default withRouter(TimeOut);


// WEBPACK FOOTER //
// ./src/components/TimeOut/TimeOut.js